import uuid from 'uuid';

import TaskStatus from './task-status';

const generateModalHtml = (id) => {
  return `
    <div id="${id}" class="modal aims_multi-task-progress-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header d-none">
            <h5 class="modal-title"></h5>
          </div>
          <div class="modal-body">
            <div class="modal-message d-none"></div>
            <div class="multi-task-list"></div>
          </div>
        </div>
      </div>
    </div>
  `;
};

const generateTaskRecordHtml = (taskId, taskName) => {
  return `
    <div class="aims_task-row task-${taskId}">
      <div class="task-name">${taskName}</div>
      <div class="progress">
        <div class="progress-bar" role="progressbar" area-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
  `;
};

/**
 * A generic modal dialog (based on Bootstrap v4) that shows the progress of multiple long running
 * tasks.
 */
export default class ProgressModal {

  /**
   * Constructor
   */
  constructor(options) {

    // Cache the options.
    this._options = options;

    // Generate a unique ID for this modal.
    this._modalId = uuid.v4();

    // Set the flag that tracks whether the modal has been inserted into the DOM.
    this._isActive = false;

    // Internal cache of the activities that are using this modal to display their progress.
    this._activeTasks = {};
    this._activeTaskCount = 0;

  }

  /**
   * Private method to insert the modal into the DOM.
   */
  _insertModal() {

    $('body').append(generateModalHtml(this._modalId));
    this._$el = $(`#${this._modalId}`);

    if (this._options && this._options.title) {
      const _$modalHeader = this._$el.find('.modal-header');
      _$modalHeader.find('.modal-title').html(this._options.title);
      _$modalHeader.removeClass('d-none');
    }

    if (this._options && this._options.message) {
      this._$el.find('.modal-message')
        .html(this._options.message)
        .removeClass('d-none');
    }

    this._$taskList = this._$el.find('.multi-task-list');

    // Init the modal.
    this._$el.modal({
      backdrop: 'static',
      keyboard: false
    });

    this._isActive = true;

  }

  /**
   * Private method to remove the modal from the DOM.
   */
  _removeModal() {

    // Clear the visual list of tasks.
    this._$taskList.empty();

    // Hide the modal to remove the modal effect (dark screen, no response to keyboard/mouse.
    this._$el.modal('hide');

    // Remove the modal from the DOM.
    this._$el.remove();

  }

  /**
   * Invoked by a task to register itself for displaying progress. This method returns a status
   * object that is used by the task to communicate progress.
   */
  registerTask(id, taskName) {

    // Insert the modal into the DOM if required.
    if (!this._isActive) {
      this._insertModal();
    }

    // Create the status object.
    const taskStatus = new TaskStatus(id, taskName, this);

    // Insert the progress bar.
    this._$taskList.append(generateTaskRecordHtml(id, taskName));
    this._activeTaskCount++;

    // Cache the task status and reference to the progress bar.
    this._activeTasks[id] = {
      taskStatus,
      el: this._$taskList.find(`.task-${id} > .progress > .progress-bar`)
    };

    return taskStatus;

  }

  /**
   * Handler invoked when the progress of a task has been updated.
   */
  handleProgress(taskStatus) {

    // Identify the active task.
    const $el = this._activeTasks[taskStatus.id].el;

    // Update the progress bar.
    const progress = taskStatus.progress;
    $el.attr('aria-valuenow', progress).css('width', `${progress}%`);

    // Remove task if progress is 100%.
    if (progress >= 100) {
      delete this._activeTasks[taskStatus.id];
      this._activeTaskCount--;
    }

    // If no active tasks remaining, remove the modal.
    if (this._activeTaskCount === 0) {
      this._removeModal();
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/multi-task-progress-modal/component.js